import {Component, Inject, Input, OnInit} from '@angular/core';
import {ConfService} from '../../conf.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AttributesListComponent} from '../../attributes-list/attributes-list.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ViewDialogComponent} from '../../api-new/api-new.component';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {SignupComponent} from '../../signup/signup.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import { Params } from '@angular/router';
import { Router } from '@angular/router';
import {AppComponent} from '../../app.component';

export interface Menu {
    name: string;
    iconClass: string;
    active: boolean;
    toolTip: string;
    submenu: { name: string, key: string, icon: string, toolTip: string }[];
}

export interface Config {
    // selector?: String,
    multi?: boolean;
}


@Component({
    selector: 'app-environment-settings',


    templateUrl: './environment-settings.component.html',
    styleUrls: ['./environment-settings.component.scss']
})
export class EnvironmentSettingsComponent implements OnInit {

    options: Config = {multi: false};
    adminMenu: Menu[] = [
        {
            name: 'Platform Experience',
            iconClass: 'fa fa-handshake-o',
            active: false,
            toolTip: 'Platform Experience',
            submenu: [
                {name: 'Platform Console', key: 'Platform Console', icon: 'fa fa-desktop', toolTip: 'Platform Console'},
                {name: 'Developer Experience', key: 'Developer Experience', icon: 'fa fa-rocket', toolTip: 'Developer Experience'},
                {name: 'API Gateway', key: 'API Gateway Manager', icon: 'fa fa-shield', toolTip: 'API Gateway'},
                {name: 'File Storage', key: 'Storage', icon: 'fa fa-folder', toolTip: 'File Storage'},
                {name: 'Databases', key: 'Databases', icon: 'fa fa-database', toolTip: 'Databases'}
            ]
        },
        {
            name: 'Identity and Access Management',
            iconClass: 'fa fa-key',
            active: false,
            toolTip: 'Identity and Access Management',
            submenu: [
                {name: 'Users', key: 'Users', icon: 'fa fa-user', toolTip: 'Users'},
                {name: 'User Groups', key: 'UserGroups', icon: 'fa fa-users', toolTip: 'User Groups'},
                {name: 'Roles', key: 'Roles', icon: 'fa fa-universal-access', toolTip: 'Roles'},
                {name: 'Secrets Manager', key: 'Secrets Manager', icon: 'fa fa-user-secret', toolTip: 'Secrets Manager'}
            ]
        },
        {
            name: 'API Security Management',
            iconClass: 'fa fa-lock',
            active: false,
            toolTip: 'API Security Management',
            submenu: [
                {name: 'Authorization Types', key: 'AuthorizationTypes', icon: 'fa fa-key', toolTip: 'Authorization Types'},
                {name: 'Consumers', key: 'Consumers', icon: 'fa fa-user-circle', toolTip: 'Consumers'},
                {name: 'Gateway Settings', key: 'GatewaySettings', icon: 'fa fa-shield', toolTip: 'Gateway Settings'}
            ]
        },
        {
            name: 'Development Environments',
            iconClass: 'fa fa-laptop',
            active: false,
            toolTip: 'Development Environments',
            submenu: [
                {name: 'Environments', key: 'Environments', icon: 'fa fa-laptop', toolTip: 'Environments'}
            ]
        },
        {
            name: 'Productivity Tools',
            iconClass: 'fa fa-wrench',
            active: false,
            toolTip: 'Productivity Tools',
            submenu: [
                {name: 'Mail Servers', key: 'EmailConfigurations', icon: 'fa fa-envelope', toolTip: 'Mail Servers'},
                {name: 'S3 Connectors', key: 'S3 Bucket Connectors', icon: 'fa fa-file-archive-o', toolTip: 'S3 Connectors'}
            ]
        },
        {
            name: 'General',
            iconClass: 'fa fa-cog',
            active: false,
            toolTip: 'General',
            submenu: [
                {name: 'Idle Timeout', key: 'IdleTimeOut', icon: 'fa fa-clock-o', toolTip: 'Idle Timeout'}
            ]
        }
    ];
    menuPanel = {};
    menu: any;
    config: Config;
    activatedTabs = {};
    environment: any;
    environmentName: any;
    i: number;
    constructor(private appComponent: AppComponent,
                private route: ActivatedRoute,
                private confPost: ConfService,
                public dialog: MatDialog,
                private _service: ConnecttocrudService,
                public accountInfoService: AccountInfoService,
                public signup: SignupComponent,
                public platform: LeftpanelComponent) {

    }

    @Input() isSignUp = false;
    @Input() environmentSummary: any;
    @Input() partnerShortCode: any;
    @Input() databaseSelected: any;
    id: any;
    environmentPayload: any;
    partner: any;
    data: any;
    data1: any;
    URLObject = {};
    timesRan: any;
    flag: any;
    environments: any;
    adminEnvironmentName: any;
    isAdminCreating = false;
    account_password = 'qwerty';
    isDisabling = false;
    keyList = [];
    payloadForEnvironmentManipulation = {};
    retries = 0;
    isTabChanged = false;
    selectedIndex = 0;
    isOptionSelected = [true, true, true];
    @Input() showFiller = true;
    settingsData: any;
    default = {
        'secretsmanager': ['providerName', 'title'],
        'databases': ['database_name', 'database_type'],
        'subscription': ['name'],
        'dashboard': ['name'],
        'devex': ['url'],
        'apigateway': ['name', 'provider'],
        'storage': ['name', 'provider'],
        's3BucketConnectors': ['name', 'provider']
    };
    services: any;
    menuItems = [];

    isOriginfromConsole = false;
    subCategoryName : any;
    defaultMenu : any;

    // config = {
    //     paddingAtStart: true,
    //     listBackgroundColor: 'rgb(208, 241, 239)',
    //     fontColor: 'rgb(8, 54, 71)',
    //     backgroundColor: 'rgb(208, 241, 239)',
    //     selectedListFontColor: 'red',
    // };
    expanded = false;

    ngOnInit() {

        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        this.route.params.subscribe(params => {
            let parameters: any;
            parameters = params;
            if (parameters && parameters.environment) {
                this.environmentName = parameters.environment;
                if (parameters.subcategory) {
                    this.isOriginfromConsole = true;
                    this.subCategoryName = parameters.subcategory;
                }
                if (localStorage.getItem('partner')) {
                    // if (!localStorage.getItem('partner').includes('-')) {
                    this.getData();

                }
            }
        });


        // this.config = this.mergeConfig(this.options);
    }

    // mergeConfig(options: Config) {
    //     // 기본 옵션
    //     const config = {
    //         // selector: '#accordion',
    //         multi: true
    //     };
    //
    //     return {...config, ...options};
    // }

    // toggle(index: number) {
    //     // 멀티 오픈을 허용하지 않으면 타깃 이외의 모든 submenu를 클로즈한다.
    //     if (!this.config.multi) {
    //         this.menus.filter(
    //             (menu, i) => i !== index && menu.active
    //         ).forEach(menu => menu.active = !menu.active);
    //     }
    //
    //     // Menu의 active를 반전
    //     this.menus[index].active = !this.menus[index].active;
    // }

    hasAuditLogsPermissions(data) {
        switch (data['type']) {
            case 'secretsmanager':
                return this.accountInfoService.hasPermission('VIEW_AUDIT_LOGS_SECRETS_MANAGER');
                break;
            case 'dashboard':
                return this.accountInfoService.hasPermission('VIEW_AUDIT_LOGS_PLATFORM_CONSOLE');
                break;
            case 'devex':
                return this.accountInfoService.hasPermission('VIEW_AUDIT_LOGS_DEVELOPER_EXPERIENCE');
                break;
            case 'apigateway':
                return this.accountInfoService.hasPermission('VIEW_AUDIT_LOGS_API_GATEWAY_MANAGER');
                break;
            case 'storage':
                return this.accountInfoService.hasPermission('VIEW_AUDIT_LOGS_STORAGE');
                break;
            case 's3BucketConnectors':
                return this.accountInfoService.hasPermission('VIEW_AUDIT_LOGS_S3_BUCKET_CONNECTOR');
                break;
            case 'emailConfigurations':
                return this.accountInfoService.hasPermission('VIEW_AUDIT_LOGS_EMAIL_CONFIGURATIONS');
                break;
            case 'time':
                return this.accountInfoService.hasPermission('VIEW_AUDIT_LOGS_IDLE_TIMEOUT_SETTINGS');
                break;
            case 'databases':
                return this.accountInfoService.hasPermission('VIEW_AUDIT_LOGS_DATABASES');
                break;
            default:
                return true;
                break;
        }
    }

    getData() {
        this.setMenu();

        if (this.platform.settingsData !== null && this.platform.settingsData !== undefined) {

            if (this.platform.settingsData && this.platform.settingsData['body'] && this.platform.settingsData['body'][0]) {
                this.id = this.platform.settingsData['body'][0]['id'];
                this.data = this.platform.settingsData['body'][0];
                this.settingsData = this.data;
                if (this.data['environments']) {
                    this.partner = localStorage.getItem('partner');
                    this.environments = this.data['environments'];
                    this.environment = this.environments.find(environment => environment.name === this.environmentName);
                    this.i = this.environments.findIndex(environment => environment.name === this.environmentName);
                    this.appComponent.ribbon = 'Environment : ' + this.environment.name;
                }
                for (let i = 0; i < this.environments.length; i++) {
                    if (!this.isOriginfromConsole) {
                        this.activatedTabs[i] = ['PlatformConsole' + i.toString()];
                        this.defaultMenu = 'Platform Console';
                    } else {
                        switch (this.subCategoryName) {
                            case 'users':
                                this.activatedTabs[i] = ['Users' + i.toString()];
                                this.defaultMenu = 'Users';
                                break;
                            case 'usergroups':
                                this.activatedTabs[i] = ['UserGroups' + i.toString()];
                                this.defaultMenu = 'User Groups';
                                break;
                            case 'roles':
                                this.activatedTabs[i] = ['Roles' + i.toString()];
                                this.defaultMenu = 'Roles';
                                break;
                            case 'consumers':
                                this.activatedTabs[i] = ['Consumers' + i.toString()];
                                this.defaultMenu = 'Consumers';
                                break;
                            case 'environments':
                                this.activatedTabs[i] = ['Environments' + i.toString()];
                                this.defaultMenu = 'Environments';
                                break;
                            default:
                                break;
                        }
                    }
                    this.menuPanel[i] = this.environments[i]['type'] === 'admin' ? JSON.parse(JSON.stringify(this.adminMenu)) : JSON.parse(JSON.stringify(this.menu));
                    this.keyList.push([]);
                    for (let j = 0; j < this.environments[i]['services'].length; j++) {

                        if (this.environments[i]['services'][j].configurations[0]) {
                            this.keyList[i].push(Object.keys(this.environments[i]['services'][j].configurations[0]));
                        }
                    }
                }
            }
        } else {

            this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false)
                .subscribe(data => {
                    this.platform.settingsData = data;
                    if (data && data['body'] && data['body'][0]) {
                        this.id = data['body'][0]['id'];
                        this.data = data['body'][0];
                        this.settingsData = this.data;
                        if (this.data['environments']) {
                            this.partner = localStorage.getItem('partner');
                            this.environments = this.data['environments'];
                            this.environment = this.environments.find(environment => environment.name === this.environmentName);
                            this.i = this.environments.findIndex(environment => environment.name === this.environmentName);
                            this.appComponent.ribbon = 'Environment : ' + this.environment.name;

                        }

                        for (let i = 0; i < this.environments.length; i++) {
                            if (!this.isOriginfromConsole) {
                                this.activatedTabs[i] = ['PlatformConsole' + i.toString()];
                                this.defaultMenu = 'Platform Console';
                            } else {
                                switch (this.subCategoryName) {
                                    case 'users':
                                        this.activatedTabs[i] = ['Users' + i.toString()];
                                        this.defaultMenu = 'Users';
                                        break;
                                    case 'usergroups':
                                        this.activatedTabs[i] = ['UserGroups' + i.toString()];
                                        this.defaultMenu = 'User Groups';
                                        break;
                                    case 'roles':
                                        this.activatedTabs[i] = ['Roles' + i.toString()];
                                        this.defaultMenu = 'Roles';
                                        break;
                                    case 'consumers':
                                        this.activatedTabs[i] = ['Consumers' + i.toString()];
                                        this.defaultMenu = 'Consumers';
                                        break;
                                    case 'environments':
                                        this.activatedTabs[i] = ['Environments' + i.toString()];
                                        this.defaultMenu = 'Environments';
                                        break;
                                    default:
                                        break;
                                }
                            }
                            this.menuPanel[i] = this.environments[i]['type'] === 'admin' ? JSON.parse(JSON.stringify(this.adminMenu)) : JSON.parse(JSON.stringify(this.menu));
                            this.keyList.push([]);
                            for (let j = 0; j < this.environments[i]['services'].length; j++) {
                                if (this.environments[i]['services'][j].configurations[0]) {
                                    this.keyList[i].push(Object.keys(this.environments[i]['services'][j].configurations[0]));
                                }
                            }
                        }
                    }

                });
        }

    }

    tabChanged(event) {
        if (event.index === 0) {
            this.isTabChanged = true;
        }
    }

    optionSelected(index, type) {
        if (type === 'Environments') {
            this.isOptionSelected[index] = false;
        } else {
            this.isOptionSelected[index] = true;
        }
    }

    typeOf(val) {
        return typeof val;
    }

    toUpper(val) {
        return val.toUpperCase();
    }

    setMenu() {
        let envMenu = [];
        envMenu = JSON.parse(JSON.stringify(this.adminMenu));
        envMenu[1].submenu.splice(0, 2);
        envMenu[2].submenu.splice(0, 1);
        envMenu[4].submenu.splice(0, 1);
        envMenu = envMenu.filter((v, i) => v.name !== 'Development Environments' && v.name !== 'General');
        // let subMenu = adMenu.find
        this.menu = envMenu;
    }

    changeFunc() {
        this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.id, this.data).subscribe(success => {
            alert('Updation successfully');
        });
    }

    constructPayloadForEnvironmentManipulation(environment) {
        return new Promise(async (resolve, reject) => {
            const partn = localStorage.getItem('partner').split('-');
            const final = partn[partn.length - 1];
            // await this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
            // });
            if (environment['type'] === 'prod' && environment['cloud'][0]['type']) {
                this.payloadForEnvironmentManipulation = {
                    'type': 'disable',
                    'partner': final,
                    'account': final,
                    'configuration': {
                        'devex': [environment['cloud'][0]['type']],
                        'dashboard': [environment['cloud'][0]['type']],
                        'storage': [environment['cloud'][0]['type']],
                        'apigateway': [environment['cloud'][0]['type']]
                    }
                };
            } else if (environment['type'] === 'prod' && !environment['cloud'][0]['type']) {
                this.payloadForEnvironmentManipulation = {
                    'type': 'disable',
                    'partner': final,
                    'account': final,
                    'configuration': {
                        'devex': ['aws'],
                        'dashboard': ['aws'],
                        'storage': ['aws'],
                        'apigateway': ['aws']
                    }
                };
            } else if (environment['type'] !== 'prod' && environment['cloud'][0]['type']) {
                this.payloadForEnvironmentManipulation = {
                    'type': 'disable',
                    'partner': environment['type'] + '-' + final,
                    'account': environment['type'] + '-' + final,
                    'configuration': {
                        'devex': [environment['cloud'][0]['type']],
                        'dashboard': [environment['cloud'][0]['type']],
                        'storage': [environment['cloud'][0]['type']],
                        'apigateway': [environment['cloud'][0]['type']]
                    }
                };
            } else {
                this.payloadForEnvironmentManipulation = {
                    'type': 'disable',
                    'partner': environment['type'] + '-' + final,
                    'account': environment['type'] + '-' + final,
                    'configuration': {
                        'devex': ['aws'],
                        'dashboard': ['aws'],
                        'storage': ['aws'],
                        'apigateway': ['aws']
                    }
                };
            }
            resolve(this.payloadForEnvironmentManipulation);
        });
    }

    enableEnvironment(environment, index) {
        this.isDisabling = true;
        this.constructPayloadForEnvironmentManipulation(environment).then(response => {
            delete this.payloadForEnvironmentManipulation['type'];
            this.enableInfrastructure(this.payloadForEnvironmentManipulation, index).then(response1 => {
                window.location.reload();
            });
        });
    }

    enableInfrastructure(payload, index) {
        return new Promise((resolve, reject) => {
            this.confPost.enableEnvironment(payload).subscribe(data => {
                this.data['environments'][index]['is_enabled'] = true;
                let adminEnvironmentAuditLogs = [];
                if (this.data['environments'][index].hasOwnProperty('audit_logs')) {
                    adminEnvironmentAuditLogs = this.data['environments'][index]['audit_logs'];
                }
                adminEnvironmentAuditLogs.push({
                    action: 'UPDATE',
                    by: localStorage.getItem('signInEmail'),
                    at: Date.now()
                });
                this.data['environments'][index]['audit_logs'] = adminEnvironmentAuditLogs;
                const adminPatchPayload = {
                    environments: this.data['environments']
                };
                this.confPost.getSettingsV2CRUD(payload['partner'], payload['account'], false).subscribe(response => {
                    if (response['body'] && response['body'][0]) {
                        const responseFromApi = response['body'][0];
                        responseFromApi['is_enabled'] = true;
                        let partnerEnvironmentAuditLogs = [];
                        if (responseFromApi['environments'][0].hasOwnProperty('audit_logs')) {
                            partnerEnvironmentAuditLogs = responseFromApi['environments'][0]['audit_logs'];
                        }
                        partnerEnvironmentAuditLogs.push({
                            action: 'UPDATE',
                            by: localStorage.getItem('signInEmail'),
                            at: Date.now()
                        });
                        responseFromApi['environments'][0]['audit_logs'] = partnerEnvironmentAuditLogs;
                        responseFromApi['environments'][0]['is_enabled'] = true;
                        const partnerPatchPayload = {
                            is_enabled: true,
                            environments: responseFromApi['environments']
                        };
                        // this.confPost.patchEntityData('services', 'services', 'v2', 'settings', responseFromApi['id'], responseFromApi).subscribe();
                        // this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.data.id, this.data).subscribe(res => {});
                        this.confPost.patchEntityData('services', 'services', 'v2', 'settings', responseFromApi['id'], partnerPatchPayload).subscribe();
                        this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.data.id, adminPatchPayload).subscribe(res => {
                        });
                        // this.confPost.getArchivedPartnerByName(payload['partner']).subscribe(response1 => {
                        //     const responseFromApi1 = response1;
                        //     delete responseFromApi1['id'];
                        //     delete responseFromApi1['_id'];
                        //     this.confPost.insertPartner(responseFromApi1).subscribe(response2 => {
                        //         this.confPost.deleteArchivedPartnerByName(payload['partner']).subscribe(response3 => {
                        //             resolve('success');
                        //         });
                        //     }, error => {
                        //         reject(error);
                        //     });
                        // });
                        this.confPost.getPartnerByName(payload['partner']).subscribe(response3 => {
                            const responseFromApi1 = response3;
                            delete responseFromApi1['id'];
                            responseFromApi1['isActive'] = true;
                            this.confPost.updatePartner(responseFromApi1).subscribe(response1 => {
                                resolve('success');
                            }, error => {
                                reject(error);
                            });
                        });
                    }
                });
            }, error => {
                this.retries += 1;
                if (this.retries <= 5) {
                    setTimeout(() => {
                        this.enableInfrastructure(payload, index).then(response => {
                            resolve('success');
                        });
                    }, 5000);
                } else {
                    this.retries = 0;
                    this.platform.handleErrorGracefully(error, 'Error while enabling environment. Please try again sometime');
                    setTimeout(() => {
                        window.location.reload();
                    }, 7000);
                    reject(error);
                }
            });
        });
    }

    deleteEnvironment(environment, index) {
        if (confirm('This action is irreversible. Do you still want to delete the environment?')) {
            this.isDisabling = true;
            this.constructPayloadForEnvironmentManipulation(environment).then(response => {
                const currentTime = Math.floor(Date.now() / 1000);
                this.confPost.getPartnerByName(this.payloadForEnvironmentManipulation['partner']).subscribe(response2 => {
                    const responseFromApi = response2;
                    const difference = currentTime - responseFromApi['archived_date'];
                    const daysDifference = Math.floor(difference / 60 / 60 / 24);
                    if (daysDifference > 0) {
                        this.payloadForEnvironmentManipulation['type'] = 'delete';
                        this.deleteInfrastructure(this.payloadForEnvironmentManipulation, index, environment).then(response1 => {
                            window.location.reload();
                        }, error => {
                            this.platform.handleErrorGracefully(error, 'Error while deleting environment. Please try again sometime');
                            this.isDisabling = false;
                        });
                    } else {
                        alert('An environment can be deleted only after a day of disabling it');
                        this.isDisabling = false;
                    }
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while deleting environment. Please try again after sometime');
                    this.isDisabling = false;
                });
            });
        }
    }

    deleteInfrastructure(payload, index, environment) {
        return new Promise((resolve, reject) => {
            // this.confPost.deleteInfra(payload).subscribe(data => {
            //     this.data['environments'].splice(index, 1);
            //     this.confPost.getSettingsV2CRUD(payload['partner'], payload['account'], false).subscribe(response => {
            //         if (response['body'] && response['body'][0]) {
            //             const responseFromApi = response['body'][0];
            //             this._service.deleteItem(responseFromApi['id'], 'v2', 'services', 'services', 'settings').subscribe(response1 => {
            //             });
            //             const adminPatchPayload = {
            //                 environments: this.data['environments']
            //             };
            //             this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.data.id, adminPatchPayload).subscribe(res => {
            //             });
            //             // this.confPost.getArchivedPartnerByName(payload['partner']).subscribe(response1 => {
            //             //     const responseFromApi1 = response1;
            //             //     this.confPost.deleteArchivedPartnerByName(responseFromApi1['partner']).subscribe(response2 => {
            //             //         resolve('success');
            //             //     });
            //             // });
            //             this.confPost.deletePartnerByName(payload['partner']).subscribe(response2 => {
            //                 resolve('success');
            //             }, error => {
            //                 reject(error);
            //             });
            //         }
            //     });
            // }, error => {
            //     this.retries += 1;
            //     if (this.retries <= 5) {
            //         setTimeout(() => {
            //             this.deleteInfrastructure(payload, index, environment).then(response => {
            //                 resolve('success');
            //             });
            //         }, 5000);
            //     } else {
            //         this.retries = 0;
            //         this.platform.handleErrorGracefully(error, 'Error while deleting environment. Please try again sometime');
            //         setTimeout(() => {
            //             window.location.reload();
            //         }, 7000);
            //         reject(error);
            //     }
            // });



            const temp = payload['partner'].split('-');
            const partnerShortCode = temp[temp.length - 1];

            const params = 'partner=' + partnerShortCode + '&environment=' + payload['partner'] + '&account=' + payload['account'] + '&engagement=false';

            this.confPost.deleteEnvironment(params).subscribe(data => {
                resolve('success');
            }, error => {
                this.retries += 1;
                if (this.retries <= 5) {
                    setTimeout(() => {
                        this.deleteInfrastructure(payload, index, environment).then(response => {
                            resolve('success');
                        });
                    }, 5000);
                } else {
                    this.retries = 0;
                    this.platform.handleErrorGracefully(error, 'Error while deleting environment. Please try again sometime');
                    setTimeout(() => {
                        window.location.reload();
                    }, 7000);
                    reject(error);
                }
            });
        });
    }

    disableEnvironment(environment, index) {
        this.isDisabling = true;
        this.constructPayloadForEnvironmentManipulation(environment).then(response => {
            this.disableInfrastructure(this.payloadForEnvironmentManipulation, index).then(response1 => {
                window.location.reload();
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while disabling the environment. Please try again after sometime.');
            });
        });
    }

    disableInfrastructure(payload, index) {
        return new Promise((resolve, reject) => {
            this.confPost.disableInfra(payload).subscribe(data => {
                this.data['environments'][index]['is_enabled'] = false;
                let adminEnvironmentAuditLogs = [];
                if (this.data['environments'][index].hasOwnProperty('audit_logs')) {
                    adminEnvironmentAuditLogs = this.data['environments'][index]['audit_logs'];
                }
                adminEnvironmentAuditLogs.push({
                    action: 'UPDATE',
                    by: localStorage.getItem('signInEmail'),
                    at: Date.now()
                });
                this.data['environments'][index]['audit_logs'] = adminEnvironmentAuditLogs;
                const adminPatchPayload = {
                    environments: this.data['environments']
                };
                this.confPost.getSettingsV2CRUD(payload['partner'], payload['account'], false).subscribe(response => {
                    if (response['body'] && response['body'][0]) {
                        const responseFromApi = response['body'][0];
                        responseFromApi['is_enabled'] = false;
                        let partnerEnvironmentAuditLogs = [];
                        if (responseFromApi['environments'][0].hasOwnProperty('audit_logs')) {
                            partnerEnvironmentAuditLogs = responseFromApi['environments'][0]['audit_logs'];
                        }
                        partnerEnvironmentAuditLogs.push({
                            action: 'UPDATE',
                            by: localStorage.getItem('signInEmail'),
                            at: Date.now()
                        });
                        responseFromApi['environments'][0]['audit_logs'] = partnerEnvironmentAuditLogs;
                        responseFromApi['environments'][0]['is_enabled'] = false;
                        const partnerPatchPayload = {
                            is_enabled: false,
                            environments: responseFromApi['environments']
                        };
                        this.confPost.patchEntityData('services', 'services', 'v2', 'settings', responseFromApi['id'], partnerPatchPayload).subscribe();
                    }
                });
                this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.data.id, adminPatchPayload).subscribe(res => {
                });
                this.confPost.getPartnerByName(payload['partner']).subscribe(response3 => {
                    const responseFromApi1 = response3;
                    delete responseFromApi1['id'];
                    responseFromApi1['archived_date'] = Math.floor(Date.now() / 1000);
                    responseFromApi1['isActive'] = false;
                    this.confPost.updatePartner(responseFromApi1).subscribe(response1 => {
                        resolve('success');
                    }, error => {
                        reject(error);
                    });
                    // this.confPost.addToArchivePartner(responseFromApi1).subscribe(response1 => {
                    //     this.confPost.deletePartnerByName(payload['partner']).subscribe(response2 => {
                    //         resolve('success');
                    //     }, error => {
                    //         reject(error);
                    //     });
                    // }, error => {
                    //     reject(error);
                    // });
                });
            }, error => {
                this.retries += 1;
                if (this.retries <= 5) {
                    setTimeout(() => {
                        this.disableInfrastructure(payload, index).then(response => {
                            resolve('success');
                        });
                    }, 5000);
                } else {
                    this.retries = 0;
                    this.platform.handleErrorGracefully(error, 'Error while disabling environment. Please try again sometime');
                    setTimeout(() => {
                        window.location.reload();
                    }, 7000);
                    reject(error);
                }
            });
        });
    }

    openAddEnv() {
        const dialogRef = this.dialog.open(AddEnvComponent, {
            width: '60%',
            data: {
                environmentPayload: this.environmentPayload,
                partner: this.partner,
                adminEnvironmentName: this.adminEnvironmentName
            }
        });
        dialogRef.afterClosed().subscribe(result => {

        });
    }

    verify(obj, a, i) {
        this.isDisabling = true;
        this.signup.validateDNS1(obj, 3, 10000).then(response => {
            // if (localStorage.getItem('partner').includes('admin-')) {
            this.confPost.getSettingsCRUD(localStorage.getItem('partner'), localStorage.getItem('account'))
                .subscribe(data1 => {
                    this.data1 = data1[0];
                    if (data1[0] && data1[0]['environments'] !== undefined) {
                        this.environments = data1[0]['environments'];
                        this.isDisabling = false;
                    } else {
                    }
                }, error => {
                    alert('Error in validating DNS distribution. Please try again after sometime');
                    this.isDisabling = false;
                });
            if (response.includes('created') || response === 'created' || response === 'verified') {
                this.environments[a]['URLs'][i]['isVerified'] = 'verified';
                this.environments[a]['URLs'][i]['envCreationStatus'] = 'success';
                this.confPost.patchEntityData('services', 'services', 'v1', 'settings', this.data.id, {'environments': this.environments}).subscribe(res => {
                    // alert('Succesfully verified');
                    // window.location.reload();
                    this.confPost.getSettingsCRUD(localStorage.getItem('partner'), localStorage.getItem('account'))
                        .subscribe(data1 => {
                            this.data1 = data1[0];
                            if (data1[0] && data1[0]['environments'] !== undefined) {
                                this.environments = data1[0]['environments'];
                                this.isDisabling = false;
                            }
                        }, error => {
                            this.isDisabling = false;
                            window.location.reload();
                        });
                }, error => {
                    alert('Error in validating DNS distribution. Please try again after sometime');
                    this.isDisabling = false;
                });
            }
            // }
            // else {
            //     const temp = localStorage.getItem('partner').split('-');
            //     let part;
            //     if (temp.length > 1) {
            //         part = temp[temp.length - 1];
            //     } else {
            //         part = localStorage.getItem('partner').split('-');
            //     }
            //     this.confPost.getSettingsCRUD('admin-' + part, 'admin-' + part)
            //         .subscribe(data1 => {
            //             this.data1 = data1[0];
            //             if (data1[0] && data1[0]['environments'] !== undefined) {
            //                 this.environments = data1[0]['environments'];
            //                 this.isDisabling = false;
            //             } else {
            //             }
            //         }, error => {
            //             alert('Error in validating DNS distribution. Please try again after sometime');
            //             this.isDisabling = false;
            //         });
            // }
        });
    }

    async createInfra(ciSelected) {
        await this.signup.createInfra(['admin'], ciSelected, this.account_password).then(async response => {
            this.signup.patchPayload.environments.push(
                {
                    'type': 'prod',
                    'URLs': [
                        {
                            'type': 'dashboard',
                            'url': localStorage.getItem('partner') + '.apiplatform.io',
                            'status': true,
                            'isVerified': 'verified',
                            'envCreationStatus': 'success'
                        },
                        {
                            'type': 'devex',
                            'url': localStorage.getItem('partner') + '.devex.apiplatform.io',
                            'status': true,
                            'isVerified': 'verified',
                            'envCreationStatus': 'success'
                        },
                        {
                            'type': 'apigateway',
                            'url': await this.platform.getDefaultGatewayURL(),
                            'status': true,
                            'isVerified': 'verified',
                            'envCreationStatus': 'success'
                        },
                        {
                            'type': 'storage',
                            'url': 'https://s3.amazonaws.com/' + localStorage.getItem('partner') + '.apiplatform.io',
                            'status': true,
                            'isVerified': 'verified',
                            'envCreationStatus': 'success'
                        }
                    ],
                    'isValidationComplete': true
                }
            );
            this.confPost.patchEntityData('services', 'services', 'v1', 'settings', this.signup.patchId, this.signup.patchPayload).subscribe(success => {
                alert('Please login to your admin account to create new environments');
            });
        });
    }

    async createAdmin() {
        this.isAdminCreating = true;
        if (this.data === undefined) {
            this.flag = false;
            const item = {
                'partner': localStorage.getItem('partner'),
                'account': localStorage.getItem('account'),
                'partner_settings': {
                    'environment': {
                        'environments': ['admin', 'prod'],
                        'is_custom': false,
                        'custom_environments': []
                    }
                },
                'environments': []
            };
            this._service.addItem(item, 'v1', 'services', 'services', 'settings').subscribe(data => {
                this.createInfra('aws').then(response1 => {
                    this.isAdminCreating = false;
                    // window.location.reload();
                });
            });
        } else if (this.data.partner_settings === undefined) {
            this.data['partner_settings'] = {
                'environment': {
                    'environments': ['admin', 'prod'],
                    'is_custom': false,
                    'custom_environments': []
                }
            };
            this.confPost.patchEntityData('services', 'services', 'v1', 'settings', this.data.id, this.data).subscribe(data => {
                this.createInfra('aws').then(response => {
                    // window.location.reload();
                });
            });
        }
    }

    update() {
        this.confPost.patchEntityData('services', 'services', 'v1', 'settings', this.data.id, this.data).subscribe(success => {
            alert('Updation Successful');
        }, err => {
            alert('Error. Please try again.');
        });
    }

    stringifyjson(val) {
        return JSON.stringify(val);
    }

    onItemSelected(item, parent = '') {
        $('.nav li').removeClass('active');
        // set active for current menu item
        $(item).addClass('active');
        $(parent).addClass('active');
    }

    setActiveMenu(event, index) {
        if (event.key !== '' && this.activatedTabs[index]) {
            this.activatedTabs[index] = [];
            this.activatedTabs[index].push(event.key);
        }
    }

    tabIsActivated(tab, index) {
        if (this.activatedTabs[index]) {
            return this.activatedTabs[index].includes(tab + index.toString());
        } else {
            return false;
        }
    }

    getId(id) {
        const str = id.split(' ').join('');
        return str;
    }
}

@Component({
    selector: 'app-addEnv',
    templateUrl: './addEnv.component.html',
    styleUrls: ['./addEnv.component.scss']
})

export class AddEnvComponent implements OnInit {
    constructor(public platform: LeftpanelComponent,
                public dialogRef: MatDialogRef<AddEnvComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
    }
}

import {Directive, HostBinding, HostListener} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AccountInfoService} from '../../user/account-info.service';

@Directive({
    selector: '[expandMenu]'
})
export class ExpandMenu {
    @HostBinding('class.active') isOpen = false;

    @HostListener('click') toggleOpen($event) {
        this.isOpen = !this.isOpen;
        return this.isOpen;
    }
}

